import { z } from 'zod';

// Header of a municipal list; select values are strings, converted in form-mapping.utils
export const municipalListSchema = z.object({
  municipalityId: z.string().min(1, 'Elegí un municipio'),
  // ISO string written by DateField; sent as `YYYY-MM-DD`
  surveyDate: z.string().optional(),
  listManagerName: z.string().trim().max(100, 'Máximo 100 caracteres'),
  observations: z.string(),
});

export type MunicipalListFormValues = z.infer<typeof municipalListSchema>;
